import React from 'react'
import "./SubStyle.css"

const CQC_Training = () => {
  return (
     <section className="OurServices">
     <h1 className="OurServices-title">Staff Training</h1>
      <p className="OurServices-pera">A well-trained workforce is the foundation of excellent care. We deliver engaging and practical training programmes tailored to the needs of care providers, helping staff develop the skills, knowledge, and confidence required to provide safe, effective, and person-centred care.</p>
         <div className="btn-container">
        <button className="OurServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default CQC_Training
